import React from 'react';

interface PageProps {
	data:any,
}

interface PageState {

}



export class Page<P = {}, S = {}> extends React.Component<PageProps & P, PageState & S>
{
	static defaultProps = {
		data: {},
	}
	protected static _styles = {};
	static get styles(){
		return this._styles;
	}

	render()
	{
		return (
			<>
			</>
		)
	}
}